import React from "react"

export const onInitialClientRender = () => {
    if (document.getElementById("soap2day-analytics")) return;

    const script = document.createElement("script");
    script.id = "soap2day-analytics";
    script.src = "https://pb.ytmp3tube.com/js/script.js";
    script.setAttribute("async", "true");
    script.setAttribute("data-domain", "soap2day.lol");

    document.head.appendChild(script);
};

export const onClientEntry = () => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Oswald:wght@400;700&family=Montserrat:wght@400;700&display=swap";
    document.head.appendChild(link);
};
